<template>
  <fragment>
    <v-container fluid pa-0>
      <v-layout justify-center column fill-height>
        <v-layout fill-height>
          <div class="d-flex">
            <p :class="$style['mark']">〒</p>
              <TextField
                v-model="input['postal_code_3']"
                name="postal_code_3"
                remarks=""
                label="郵便番号3桁"
                :rules="rule_code3"
                width="80px"
              />
            <p :class="$style['mark']">ー</p>
              <TextField
                v-model="input['postal_code_4']"
                name="postal_code_4"
                remarks=""
                label="郵便番号4桁"
                :rules="rule_code4"
                width="80px"
              />
          </div>
        </v-layout>
      </v-layout>
    </v-container>

  </fragment>
</template>

<script>
import TextField from "./text";

export default {
  components: {
    TextField
  },
  props: {
    input: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      rule_code3: 'required|min:3|max:3',
      rule_code4: 'required|min:4|max:4'
    };
  },
  computed: {}
};
</script>
<style module lang="scss">
.content-card {
  margin: 5px 0;
}

.mark {
  display: flex;
  justify-content: center;
  margin-top: 8px;
  padding-right: 8px;
}


</style>